import { makeStyles } from '@material-ui/core/styles';
import { secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { colors, spacing, breakpoints, radius, fonts, fontSize } = redesignTheme;

export const useHomePageEvolutionToolsSectionStyles = makeStyles(() => ({
  sectionBeige: {
    width: '100%',
    padding: `${spacing.lg}px ${spacing.sm}px`,
    backgroundColor: colors.background,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: '64px 80px',
    },
  },
  toolsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.md,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
  },
  toolCard: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: radius.lg,
    backgroundColor: colors.white,
    overflow: 'hidden',
  },
  toolImageWrap: {
    position: 'relative',
    width: '100%',
    aspectRatio: '406 / 279',
    backgroundColor: colors.border,
  },
  toolBadge: {
    position: 'absolute',
    left: spacing.sm,
    bottom: spacing.sm,
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    padding: '8px 16px',
    borderRadius: radius.lg,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    zIndex: 1,
  },
  toolBadgeIcon: {
    width: 20,
    height: 20,
    color: colors.white,
    flexShrink: 0,
  },
  toolBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: `${spacing.sm}px ${spacing.sm}px ${spacing.md}px`,
    flex: 1,
  },
  toolTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  toolFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    marginTop: 'auto',
  },
  toolTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.lg,
    color: colors.textBody,
    lineHeight: 'normal',
  },
  toolDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.intro,
    color: colors.textBody,
    lineHeight: 'normal',
  },
  toolCountRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
  },
  toolCountBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    borderRadius: 4,
    backgroundColor: colors.background,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    color: colors.text,
    minWidth: 28,
  },
  toolCountLabel: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
  },
  textLinkButton: {
    ...secondaryButtonStyle,
    alignSelf: 'flex-start',
  },
}));
